// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles pour LotsViewByLotTechnique
 * Affichage des lots techniques avec blocs depliables
 */

.lots-view-by-technique {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  position: relative;
}

.lots-view-empty {
  padding: 2rem;
  text-align: center;
}

.lots-view-empty .no-data {
  color: #6b7280;
  font-style: italic;
}

/* Blocs de lots */
.lots-blocks {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.lot-block {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.lot-block.expanded {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Header du bloc */
.lot-block-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.2rem 1.6rem;
  background: #f9fafb;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.2s;
}

.lot-block-header:hover {
  background: #f3f4f6;
}

.lot-block.expanded .lot-block-header {
  border-bottom: 1px solid #e5e7eb;
}

.toggle-icon {
  font-family: monospace;
  font-size: 1.2rem;
  color: #6b7280;
  width: 2rem;
  text-align: center;
}

.lot-info {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  flex: 1 1;
}

.lot-code {
  font-weight: 600;
  color: #1f2937;
  background: #e5e7eb;
  padding: 0.2rem 0.6rem;
  border-radius: 4px;
  font-size: 1.3rem;
}

.lot-nom {
  color: #374151;
  font-size: 1.4rem;
}

.ac-indicator {
  font-size: 1.1rem;
  color: #374151;
  font-weight: 500;
  background: #f9fafb;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
}

.zone-type {
  font-size: 1.2rem;
  color: #6b7280;
  padding: 0.3rem 0.8rem;
  background: #f9fafb;
  border-radius: 4px;
}

.zone-count {
  font-size: 1.2rem;
  color: #374151;
  font-weight: 500;
}

/* Contenu du bloc */
.lot-block-content {
  padding: 1.6rem;
}

.no-zones {
  color: #9ca3af;
  font-style: italic;
  text-align: center;
  margin: 0;
}

/* Liste des regions/departements */
.regions-list,
.departements-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
}

.region-tag,
.dept-tag {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  font-size: 1.3rem;
  border-radius: 4px;
  background: #fff;
  color: #374151;
  border: 1px solid #e5e7eb;
}

/* Pas de couleur differente pour region - meme style */
.region-tag {
  background: #fff;
  color: #374151;
  border-color: #e5e7eb;
}

/* Animation d'expansion */
.lot-block-content {
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ==========================================
 * FRONT-09: Styles pour lots AC (verrouilles)
 * Style discret, meme code couleur existant
 * ========================================== */

/* Badge rang AC - style discret */
.rang-badge {
  font-size: 1.1rem;
  font-weight: 600;
  color: #374151;
  background: #f9fafb;
  padding: 0.3rem 0.8rem;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
  margin-left: 0.5rem;
}

/* Bloc verrouille - bordure subtile */
.lot-block--locked {
  border-color: #d1d5db;
  background: #fafafa;
}

.lot-block--locked .lot-block-header {
  background: #f5f5f5;
}

.lot-block--locked .lot-block-header:hover {
  background: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profil/components/LotsViewByLotTechnique.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA,mCAAmC;AACnC;;EAEE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,uDAAuD;AACvD;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;+CAG+C;;AAE/C,kCAAkC;AAClC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/**\n * Styles pour LotsViewByLotTechnique\n * Affichage des lots techniques avec blocs depliables\n */\n\n.lots-view-by-technique {\n  display: flex;\n  flex-direction: column;\n  gap: 1.6rem;\n  position: relative;\n}\n\n.lots-view-empty {\n  padding: 2rem;\n  text-align: center;\n}\n\n.lots-view-empty .no-data {\n  color: #6b7280;\n  font-style: italic;\n}\n\n/* Blocs de lots */\n.lots-blocks {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.lot-block {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.lot-block.expanded {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* Header du bloc */\n.lot-block-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.2rem 1.6rem;\n  background: #f9fafb;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.2s;\n}\n\n.lot-block-header:hover {\n  background: #f3f4f6;\n}\n\n.lot-block.expanded .lot-block-header {\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.toggle-icon {\n  font-family: monospace;\n  font-size: 1.2rem;\n  color: #6b7280;\n  width: 2rem;\n  text-align: center;\n}\n\n.lot-info {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  flex: 1;\n}\n\n.lot-code {\n  font-weight: 600;\n  color: #1f2937;\n  background: #e5e7eb;\n  padding: 0.2rem 0.6rem;\n  border-radius: 4px;\n  font-size: 1.3rem;\n}\n\n.lot-nom {\n  color: #374151;\n  font-size: 1.4rem;\n}\n\n.ac-indicator {\n  font-size: 1.1rem;\n  color: #374151;\n  font-weight: 500;\n  background: #f9fafb;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  border: 1px solid #e5e7eb;\n}\n\n.zone-type {\n  font-size: 1.2rem;\n  color: #6b7280;\n  padding: 0.3rem 0.8rem;\n  background: #f9fafb;\n  border-radius: 4px;\n}\n\n.zone-count {\n  font-size: 1.2rem;\n  color: #374151;\n  font-weight: 500;\n}\n\n/* Contenu du bloc */\n.lot-block-content {\n  padding: 1.6rem;\n}\n\n.no-zones {\n  color: #9ca3af;\n  font-style: italic;\n  text-align: center;\n  margin: 0;\n}\n\n/* Liste des regions/departements */\n.regions-list,\n.departements-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.8rem;\n}\n\n.region-tag,\n.dept-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  font-size: 1.3rem;\n  border-radius: 4px;\n  background: #fff;\n  color: #374151;\n  border: 1px solid #e5e7eb;\n}\n\n/* Pas de couleur differente pour region - meme style */\n.region-tag {\n  background: #fff;\n  color: #374151;\n  border-color: #e5e7eb;\n}\n\n/* Animation d'expansion */\n.lot-block-content {\n  animation: slideDown 0.2s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ==========================================\n * FRONT-09: Styles pour lots AC (verrouilles)\n * Style discret, meme code couleur existant\n * ========================================== */\n\n/* Badge rang AC - style discret */\n.rang-badge {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #374151;\n  background: #f9fafb;\n  padding: 0.3rem 0.8rem;\n  border-radius: 4px;\n  border: 1px solid #e5e7eb;\n  margin-left: 0.5rem;\n}\n\n/* Bloc verrouille - bordure subtile */\n.lot-block--locked {\n  border-color: #d1d5db;\n  background: #fafafa;\n}\n\n.lot-block--locked .lot-block-header {\n  background: #f5f5f5;\n}\n\n.lot-block--locked .lot-block-header:hover {\n  background: #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
